import React from "react";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "../../../components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { ChevronRight } from "lucide-react";

// EMAILS-IMPL-007: a small, Emails-specific presentational table shell,
// visually matching the existing War Room Email Marketing tables
// (EmailAngleTable.jsx / EmailCreativeCatalogTable.jsx -- same `glass
// border-white/10` Card, same slate-400 headers, same
// cursor-pointer/hover:bg-white/5 rows) without reusing those components
// directly: they're P3-owned, tied to a different (analytics-rollup) data
// shape, and refactoring them to also serve authoring/catalog rows would be
// the kind of invasive cross-workstream change this checkpoint avoids.
export default function CatalogTable({
  title,
  icon: Icon,
  headerAction,
  rows,
  columns,
  getRowKey,
  onRowClick,
  emptyTitle,
  emptySubtitle,
  testId,
}) {
  const data = rows || [];

  return (
    <Card className="glass border-white/10" data-testid={testId}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <CardTitle className="flex items-center gap-2 text-lg text-slate-100">
          {Icon ? <Icon className="h-5 w-5 text-violet-400" /> : null}
          {title}
        </CardTitle>
        {headerAction}
      </CardHeader>
      <CardContent>
        {data.length === 0 ? (
          <div className="p-8 text-center text-slate-400" data-testid={`${testId}-empty`}>
            <p className="text-lg">{emptyTitle}</p>
            {emptySubtitle ? <p className="mt-2 text-sm">{emptySubtitle}</p> : null}
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow className="border-white/10 hover:bg-transparent">
                {onRowClick ? <TableHead className="w-8 text-slate-400" /> : null}
                {columns.map((col) => (
                  <TableHead
                    key={col.key}
                    className={`text-slate-400 ${col.align === "right" ? "text-right" : ""}`}
                  >
                    {col.label}
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((row) => {
                const key = getRowKey(row);
                return (
                  <TableRow
                    key={key}
                    className={`border-white/10 ${onRowClick ? "cursor-pointer hover:bg-white/5" : ""}`}
                    data-testid={`${testId}-row-${key}`}
                    onClick={onRowClick ? () => onRowClick(row) : undefined}
                  >
                    {onRowClick ? (
                      <TableCell>
                        <ChevronRight className="h-4 w-4 text-slate-400" data-testid={`${testId}-open-${key}`} />
                      </TableCell>
                    ) : null}
                    {columns.map((col) => (
                      <TableCell
                        key={col.key}
                        className={col.align === "right" ? "text-right" : undefined}
                      >
                        {col.render ? col.render(row) : row[col.key]}
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
